export default ($stateProvider) => {
  $stateProvider
    .state('wrapper.settings-callwaiting', {
      url: 'settings-callwaiting',
      template: '<nets-callwaiting></nets-callwaiting>',
    });
};
